import { DesignEditorPlugin } from '@gelato-api-ui/core/design-editor/types/design-editor-plugin.enum';

export const notAvailablePluginsForGuest = [
  DesignEditorPlugin.APP_TEXT_EFFECTS,
  DesignEditorPlugin.APP_BACKGROUND_REMOVAL,
  DesignEditorPlugin.APP_IMAGE_ENHANCEMENT,
  DesignEditorPlugin.APP_TEXT_EFFECTS,
  DesignEditorPlugin.APP_ADVANCED_PERSONALIZATION,
  DesignEditorPlugin.APP_IMAGE_FILTERS,
  DesignEditorPlugin.APP_FONTS,
];

export const hiddenEmbroideryPlugins = [
  DesignEditorPlugin.APP_BACKGROUND_REMOVAL,
  DesignEditorPlugin.APP_IMAGE_ENHANCEMENT,
  DesignEditorPlugin.APP_GETTY_IMAGES,
  DesignEditorPlugin.APP_SHUTTERSTOCK,
  DesignEditorPlugin.APP_SHUTTERSTOCK_ESSENTIAL,
  DesignEditorPlugin.APP_SHUTTERSTOCK_FULL,
  DesignEditorPlugin.APP_TEXT_EFFECTS,
  DesignEditorPlugin.APP_IMAGE_FILTERS,
  DesignEditorPlugin.APP_ADVANCED_PERSONALIZATION,
];
